import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BusinessPayment from "./component";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
const BusinessPaymentContainer = () => {
  const navigate = useNavigate();
  const { makeApiRequest } = useApiRequest();

  const [otpcode, setOtpcode] = useState("");
  const [email, setEmail] = useState("");
  const [emailFlag, setEmailFlag] = useState(true);
  const [optflag, setOtpfalg] = useState(false);
  const [pageCounter, setPageCounter] = useState(0);
  const [verificationAttemptId, setVerificationAttemptId] = useState("");
  const [loader, setLoader] = useState(false);
  const [remainingTime, setRemainingTime] = useState(60);
  const [isDisabled, setIsDisabled] = useState(false);

  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  // redirect if not logged in
  useEffect(() => {
    if (!UserJWTAuth) navigate("/");
  }, [UserJWTAuth, navigate]);

  // resend timer
  useEffect(() => {
    if (!isDisabled) return;
    const timer = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [isDisabled]);

  // Handlers
  const handleChangeEmail = (e) =>{ 
    //logger.log("email",e.target.value)
    
    setEmail(e.target.value);}
  const handleChangeOtp = (val) => setOtpcode(val);

  const handleSubmit = (e) => {
    e.preventDefault();
    const EMAIL_REGEX =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    if (!EMAIL_REGEX.test(email)) {
      toast.error("Invalid email address", { position: "top-right", autoClose: 1200 });
      return;
    }
    linkBpApi();
  };

  const handleSendOTP = () => {
    linkBpApi();
    setRemainingTime(60);
    setIsDisabled(true);
  };

  const submitOtp = () => {
    //logger.log("otpcode",otpcode)
    setLoader(true);
    makeApiRequest({
      
      url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/business-profile/code/verify`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: {
        request: { verificationAttemptId, passCode: parseInt(otpcode) },
      },
      handleSuccess: (response) => {
        setLoader(false);
        if (response.data.status === "SUCCESS") {
          toast.success("Business Profile linked successfully!", {
            position: "top-right",
            autoClose: 1500,
          });
          navigate("/paymentOptions", { replace: true });
          setEmailFlag(false);
          setOtpfalg(false);
        } else {
          toast.error(response.data.statusMessage || "Verification failed", {
            position: "top-right",
            autoClose: 1200,
          });
        }
      },
      handleError: () => {
        setLoader(false);
        toast.error("Failed to verify OTP", { position: "top-right", autoClose: 1200 });
      },
    });
  };

  const linkBpApi = () => {
const payload={ businessEmail: email, sourcePlatform: "web", "x-device-id": deviceId }
//logger.log("payload",payload)
    setLoader(true);
    makeApiRequest({
     
      url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/business-profile/register`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: { request:payload},
      handleSuccess: (response) => {
        setLoader(false);
        if (response.data.status === "SUCCESS") {
          setVerificationAttemptId(response.data?.response?.verificationAttemptId || "");
          setEmailFlag(false);
          setOtpfalg(true);
          setPageCounter(2);
          setIsDisabled(true);
        } else {
          toast.error(response.data.statusMessage || "BP link failed", {
            position: "top-right",
            autoClose: 1200,
          });
        }
      },
      handleError: (error) => {
        setLoader(false);
        if ([401, 403].includes(error.response?.status)) {
          navigate("/login");
        } else {
          toast.error("An error occurred", { position: "top-right", autoClose: 1200 });
        }
      },
    });
  };

  const resendOtpBpApi = () => {
    makeApiRequest({
    
      url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/business-profile/code/resend`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      request: { request: { verificationAttemptId } },
      handleSuccess: (response) => {
        setVerificationAttemptId(response.data?.response?.verificationAttemptId || "");
      },
      handleError:()=>{
        
      }
    });
  };

  return (
    <BusinessPayment
      otpcode={otpcode}
      handleChangeOtp={handleChangeOtp}
      handleChangeEmail={handleChangeEmail}
      handleSubmit={handleSubmit}
      optflag={optflag}
      emailFlag={emailFlag}
      submitOtp={submitOtp}
      pageCounter={pageCounter}
      setPageCounter={setPageCounter}
      handleSendOTP={handleSendOTP}
      email={email}
      remainingTime={remainingTime}
      isDisabled={isDisabled}
      loader={loader}
    />
  );
};

export default BusinessPaymentContainer;
